import { Component, inject } from '@angular/core';
import { AuthActions } from '@core/auth/store';
import { Store } from '@ngrx/store';
import { ErrorInfo } from '@shared/error-page/error-page.component';
import { ErrorPageComponent } from '../../../shared/error-page/error-page.component';

@Component({
  selector: 'app-not-authorized',
  template: '<app-error-page [error]="error" />',
  imports: [ErrorPageComponent],
})
export class NotAuthorizedComponent {
  private _store = inject(Store);

  error: ErrorInfo;

  constructor() {
    this.error = {
      code: '403',
      message: 'You are not authorized.',
      details: 'You tried to access a page you did not have prior permission for. Contact with your administrator.',
      actions: [
        {
          title: 'Logout',
          handler: this.onLogoutClick.bind(this),
        },
      ],
    };
  }

  onLogoutClick() {
    this._store.dispatch(new AuthActions.Logout());
  }
}
